import { Link } from 'react-router-dom';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center px-4">
            <div className="max-w-2xl w-full text-center">
                {/* Logo Dentometric */}
                <div className="mb-6">
                    <img 
                        src="/images/logo.png" 
                        alt="Dentometric" 
                        className="h-20 mx-auto"
                    />
                </div>

                {/* Ilustración 404 */}
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#0033ff] to-[#11cdef] mb-4">
                        404
                    </h1>
                    <div className="relative">
                        <svg 
                            className="w-64 h-64 mx-auto opacity-20" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor"
                        >
                            <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth={0.5} 
                                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                            />
                        </svg>
                    </div>
                </div>

                {/* Contenido */}
                <div className="bg-white rounded-2xl shadow-xl p-8 mb-6">
                    <h2 className="text-3xl font-bold text-gray-900 mb-3">
                        ¡Oops! Página no encontrada
                    </h2>
                    <p className="text-gray-600 text-lg mb-6">
                        La página que buscas no existe o ha sido movida. 
                        Verifica la URL o regresa al inicio.
                    </p>

                    {/* Botones de acción */}
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <button
                            onClick={() => window.history.back()}
                            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors"
                        >
                            <ArrowLeftIcon className="h-5 w-5" />
                            Volver atrás
                        </button>
                        <Link
                            to="/admin"
                            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#11cdef] text-white rounded-lg font-medium hover:bg-[#0ea5e9] transition-colors shadow-md cursor-pointer"
                        >
                            <HomeIcon className="h-5 w-5" />
                            Ir al inicio
                        </Link>
                    </div>
                </div>

                {/* Enlaces útiles */}
                <div className="text-sm text-gray-500">
                    <p className="mb-2">¿Necesitas ayuda? Visita estas secciones:</p>
                    <div className="flex flex-wrap gap-3 justify-center">
                        <Link to="/admin/usuarios" className="text-blue-600 hover:text-blue-800 hover:underline">
                            Usuarios
                        </Link>
                        <span>•</span>
                        <Link to="/admin/agenda" className="text-blue-600 hover:text-blue-800 hover:underline">
                            Agenda
                        </Link>
                        <span>•</span>
                        <Link to="/admin/servicios" className="text-blue-600 hover:text-blue-800 hover:underline">
                            Servicios
                        </Link>
                        <span>•</span>
                        <Link to="/admin/sucursales" className="text-blue-600 hover:text-blue-800 hover:underline">
                            Sucursales
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
